import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-extra-event',
  template: ``,
  styles: ['']
})
export class ExtraEventComponent implements OnInit, OnDestroy {

  accountSelectedSubscription: Subscription;
  unsubscribe$ = new Subject();
  
  constructor(private commonService: CommonService,
    private accountService: AccountService) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(account => {
      this.getBasicData(account.clientCode);
    })
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getBasicData(clientCode: string) {
    this.accountService.getBasicData(clientCode)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(response => {
      if (response.valid) {
        this.commonService.announceAccountDataFetched(response.data);
      }
    });
  }
}
